// extracted by mini-css-extract-plugin
module.exports = {"container":"iXAnbdv0AshEN1rDGHz7-A==","logoLink":"pBvGj27+bsdLX+nPGtU78Q==","logoCaptionText":"oCIUINjA6cGVjbZa8qh5UQ==","logoImage":"eEAbqmzaILXA0CLQ8bMpnw=="};